import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination
} from '@material-ui/core'
import { FeedbackTypeText } from 'common/enum'

const PromoTable = props => {
  const { data, page, onPageChange } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>User</TableCell>
                  <TableCell>Comment</TableCell>
                  <TableCell>Read</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data.rows && data.rows.map(feedback => (
                  <TableRow key={feedback.id} hover>
                    <TableCell>{feedback.id}</TableCell>
                    <TableCell>{feedback.user && feedback.user.name}</TableCell>
                    <TableCell>{feedback.comment}</TableCell>
                    <TableCell>{feedback.read ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{FeedbackTypeText[feedback.type]}</TableCell>
                    <TableCell>{formatDateTime(feedback.createdAt)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={data.count || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default PromoTable